// Refer to https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#Unique_file_type_specifiers
// * Mozilla Firefox interpretes 'image/jpeg' as .jfif (https://stackoverflow.com/questions/52659828/firefox-sometimes-ignores-jpeg-files-with-jpg-and-jpeg-extensions-on-file-inpu)
export const ALLOWED_MEDIA_UPLOAD_MIMES: string =
  '.jpeg, .jpg, image/jpeg, image/png, video/mp4, video/mpeg, video/webm';

export const foo: string = 'foo';
